import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {scheduleState, setSelectedScheduleAction,} from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import {OperationAlertDeliveryGroup} from "../../types/alert/operation-alert-delivery-group";
import {timeFormat} from "../../utils/date/date-format";
import TimeLineIcon from "../icons/TimeLineIcon";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";
import React from "react";
import {LineNumberLabel} from "../label/line-number-label";
import {EMPTY_LINE_NAME, NOT_ASSIGNED_SCHEDULE} from "../../utils/static/schedule-static";

interface Props {
    isNew: boolean;
    alert: OperationAlertDeliveryGroup;
}

export const WithoutPhotoAndDelayContentsBodyItem: React.FC<Props> = (
    {
        isNew,
        alert,
    }
) => {
    const dispatch = useAppDispatch();
    const {schedulePageAll} = useAppSelector(scheduleState);

    const handleClickDelayLineBox = (scheduleId: string) => {
        const selectedSchedule = schedulePageAll.contents.find(
            (schedule) => schedule.id === scheduleId
        );
        if (!selectedSchedule) {
            return;
        }
        dispatch(setSelectedScheduleAction({selectedSchedule}));
    };

    return (
        <DelayListDeliveryGroup
            key={alert.schedule.id}
            onClick={() => {
                handleClickDelayLineBox(alert.schedule.id);
            }}
        >
            {isNew && <DelayListAlertCircle/>}
            <DelayListTitleBox>
                <DelayListTitleBoxLabel1>
                    {`  
                    ${alert.schedule.worker?.name || NOT_ASSIGNED_SCHEDULE} / 
                    ${alert.schedule.alias || EMPTY_LINE_NAME}
                    `}
                </DelayListTitleBoxLabel1>
                <DelayListTitleBoxLabel2>
                    <LineNumberLabel
                        backgroundColor={alert.deliveryGroup.type === DeliveryGroupType.PickUp ? theme.palette.primitives.blue400 : theme.palette.primitives.yellow400}>
                        {alert.deliveryGroupIndex + 1}</LineNumberLabel>
                    {`${alert.deliveryGroup.type === DeliveryGroupType.PickUp ? "상차" : "전달"} / ${alert.deliveryGroup.formattedAddress}`}
                </DelayListTitleBoxLabel2>
            </DelayListTitleBox>
            <Width24/>
            <DelayListTimeBox>
                <DelayTimeIcon className="requestTime"/>
                <span className="requestTime">
          {timeFormat(alert.deliveryGroup.startTimeLimited)}
        </span>
            </DelayListTimeBox>
            <Width24/>
            <DelayListTimeBox>
                <DelayTimeIcon className="delayTime"/>
                <span className="delayTime">
          {timeFormat(alert.deliveryGroup.reportedAt)}
        </span>
            </DelayListTimeBox>
        </DelayListDeliveryGroup>
    );
};

const DelayListDeliveryGroup = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding: 11px 32px 13px 32px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background-color: ${theme.palette.primitives.gray50};
  }
`;

const DelayListAlertCircle = styled.span`
  position: absolute;
  width: 8px;
  height: 8px;
  top: 16px;
  left: 16px;
  border-radius: 999px;
  background-color: ${theme.palette.primitives.red500};
`;

const DelayListTitleBox = styled.div`
  width: 176px;
  padding: 0;
  margin: 0;
`;

const DelayListTitleBoxLabel1 = styled.p`
  font-weight: 600;
  width: 176px;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.palette.primitives.black};
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DelayListTitleBoxLabel2 = styled.div`
  font-weight: 400;
  width: 176px;
  font-size: 12px;
  line-height: 14px;
  color: ${theme.palette.primitives.gray600};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  align-items: center;
`;

const DelayListTimeBox = styled.div`
  text-align: center;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  gap: 2px;

  & > .requestTime {
    color: ${theme.palette.primitives.gray600};
  }

  & > .delayTime {
    color: ${theme.palette.primitives.red500};
  }
`;

const DelayTimeIcon = styled(TimeLineIcon)`
  width: 14px;
  height: 14px;
  cursor: pointer;

  &.requestTime {
    fill: ${theme.palette.primitives.gray400};
  }

  &.delayTime {
    fill: ${theme.palette.primitives.red500};
  }
`;

const Width24 = styled.div`
  padding: 0 12px;
`;
